import { render, staticRenderFns } from "./caseImportModal.vue?vue&type=template&id=c52926c2&scoped=true"
import script from "./caseImportModal.vue?vue&type=script&lang=js"
export * from "./caseImportModal.vue?vue&type=script&lang=js"
import style0 from "./caseImportModal.vue?vue&type=style&index=0&id=c52926c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52926c2",
  null
  
)

export default component.exports